import React from 'react';

import { ManageOrganizationWrapper } from 'screens/organizations/context/EditOrganizationProvider';

import OrganizationTitles from 'screens/organizations/components/OrganizationTitles';

const OrganizationTitlesScreen = () => <OrganizationTitles />;

export default OrganizationTitlesScreen;

OrganizationTitlesScreen.getLayout = (page) => (
  <ManageOrganizationWrapper>{page}</ManageOrganizationWrapper>
);
